import React from 'react';

import { Props } from './';
import { StatsItem } from './components/stats-item';

export const Stats: React.FC<Props> = ({ title, items }) => (
  <section className="mb-12" aria-label={title ?? 'stats'}>
    {title && <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>}

    <div className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow md:grid-cols-3">
      {items.map((item, index) => (
        <StatsItem key={`CAMBIAR-INDEX-${index}`} {...item} />
      ))}
    </div>
  </section>
);
